import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  Paper,
  Typography,
  Card,
  CardContent,
} from '@material-ui/core';
import image from '../../common/icons/user.svg';
import { makeStyles } from '@material-ui/core/styles';
import { goOut } from '../../../helpers/AuthenticationHelper';

const useStyles = makeStyles(() => ({
  center: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  card: {
    width: 320,
    lineHeight: 1.5,
    textAlign: 'center',
  },
  text1: {
    marginTop: 8,
    marginBottom: 24,
  },
  text2: {
    marginBottom: 28,
  },
}));

const LogoutModal = () => {
  const [counter, setCounter] = useState(6);
  const loggedSituation = useSelector(
    (state) => state.authenticationReducer.userAuth,
  );

  useEffect(() => {
    if (loggedSituation === 'must_out') {
      counter > 0 ? setTimeout(() => setCounter(counter - 1), 1000) : goOut();
    }
  });

  const classes = useStyles();
  return (
    <Dialog open={loggedSituation === 'must_out'}>
      <Paper
        style={{ width: 320, height: 165, backgroundColor: '#F6F5FB' }}
        className={classes.center}
      >
        <img src={image} style={{ width: 112, height: 112 }} />
      </Paper>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h2" className={classes.text1}>
            Sesión expirada
          </Typography>
          <Typography variant="h5" className={classes.text2}>
            Por seguridad tu sesión finalizó, en {counter} segundos serás
            redirigido para iniciar una nueva sesión.
          </Typography>
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default LogoutModal;
